import { render, staticRenderFns } from "./NbNewUploader.vue?vue&type=template&id=c8ee50c6&scoped=true&lang=pug"
import script from "./NbNewUploader.vue?vue&type=script&lang=ts"
export * from "./NbNewUploader.vue?vue&type=script&lang=ts"
import style0 from "./NbNewUploader.vue?vue&type=style&index=0&id=c8ee50c6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ee50c6",
  null
  
)

export default component.exports